import * as React from 'react';

import { useAuth, type AuthRole } from '@/auth/auth-context';

// =============================================================================
// env-chip.tsx — Pastille d'environnement (design system, différenciateur produit).
// =============================================================================
// DS « Product differences » : ADMIN = pastille amber « Production · v1.0 » ;
// FOURNISSEUR = pastille teal (--chart-2) « Espace fournisseur ». La couleur est
// TOUJOURS doublée d'un libellé texte (WCAG 1.4.1 — jamais l'info par la seule couleur).
// Décoratif informatif : un point coloré (aria-hidden) + le libellé porteur.

export function EnvChip(): React.JSX.Element {
  const auth = useAuth();
  const role: AuthRole = auth.role ?? 'admin';
  const isSupplier = role === 'supplier';

  const label = isSupplier ? 'Espace fournisseur' : 'Production · v1.0';
  // Amber (admin) via accent ; teal (fournisseur) via token chart-2.
  const tone = isSupplier
    ? 'border-chart-2/30 bg-chart-2/10 text-chart-2'
    : 'border-primary/25 bg-accent text-accent-foreground';

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-mono text-[11px] font-medium tracking-tight ${tone}`}
    >
      <span
        aria-hidden="true"
        className={`h-1.5 w-1.5 rounded-full ${isSupplier ? 'bg-chart-2' : 'bg-primary'}`}
      />
      {label}
    </span>
  );
}
